<template>
  <div class="form_wrapper">
    <PageTitle :value="title" />
    <Search
        :searchFn="onSearch"
        :clearFn="onClear"
        label="기업검색" />
    <v-app>
      <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="displayItems"
      :hide-default-footer="true"
      :server-items-length="allItems.length"
      >
        <template #[`item.dataPurchase`]="{ item }">
          <v-btn
              class="blue-grey lighten-4"
              @click="(event) => handleToDataPurchasePage(event, item)"
          >
            <v-icon small>
              mdi-database-search-outline
            </v-icon>
          </v-btn>
        </template>

        <template #[`item.dataUse`]="{ item }">
          <v-btn
              class="blue-grey lighten-4"
              @click="(event) => handleToDataUsePage(event, item)"
          >
            <v-icon small>
              mdi-database-search-outline
            </v-icon>
          </v-btn>
        </template>

      </v-data-table>

      <div class="footer_wrapper">
        <div class="first_btn">
          <button class="btn" @click="handleFirstPage">
            {{ "처음" }}
          </button>
        </div>
        <div class="middle_btn">
          <button class="btn" @click="handlePrevPage" :disabled="currentPage===1">
            {{ "이전" }}
          </button>
          <div class="page">
            {{ currentPage }} / {{ pageTotal }}
          </div>
          <button class="btn" @click="handleNextPage" :disabled="currentPage===pageTotal">
            {{ "다음" }}
          </button>
        </div>
        <div class="page_selector_wrapper">
          <v-select
              class="page_selector"
              v-model="itemsPerPage"
              :items="pageSizes"
              dense
              hide-details
              @change="handleChangeItemsPerPage"
          />
        </div>
      </div>


    </v-app>
  </div>
</template>

<script>
import CreateButton from "@/components/common/buttons/CreateButton"
import TableIcon from "@/components/lookup/TableIcon"
import table from "@/mixins/table"
import { MENU, CATEGORY } from "@/constants/mapVarNames"
import { formatISOString, } from "@/utils/format"
import FilterListItem from "@/components/lookup/FilterListItem.vue";
import http from "@/api/http";
import {DEFAULT_PAGE_SIZE} from "@/constants/sizes";
import * as lookupApi from "@/api/lookup";
import PageTitle from "@/components/common/headers/PageTitle.vue";
import Search from "@/components/common/Search.vue";

export default {
  components: {
    TableIcon,
    FilterListItem,
  },
  mixins: [table],
  data() {
    return {
      title: "구매 관리",
      allItems: [],
      searchKeyword: "",

      itemsPerPage: 20,
      pageSizes: [20, 50, 100],
      currentPage: 1,

      headers: [

        {
          text: "id",
          value: "id",
        },
        {
          text: "아이디",
          value: "username",
        },
        {
          text: "회사명",
          value: "company_name",
        },
        {
          text: "총구매",
          value: "purchase.purchase_count",
        },
        {
          text: "사용 가능(건)",
          value: "purchase.unuse_count",
        },
        {
          text: "사용 완료(건)",
          value: "purchase.use_count",
        },
        {
          text: "구매 관리",
          value: "dataPurchase",
          sortable: false,
        },
        {
          text: "사용 내역 조회",
          value: "dataUse",
          sortable: false,
        },

      ],
    }
  },
  created() {
    this.$store.commit("SET_LOOKUP_CATEGORY", { menu: MENU.game, category: CATEGORY.history, })
  },
  computed: {
    filteredItems() {
      const kw = this.searchKeyword.trim().toLowerCase();
      if (!kw) {
        return this.allItems;
      }
      return this.allItems.filter(item =>
          String(item.company_name || "")
              .toLowerCase()
              .includes(kw)
      );
    },
    // 2) 전체 페이지 수 (필터 적용 후)
    pageTotal() {
      return Math.max(1, Math.ceil(this.filteredItems.length / this.itemsPerPage));
    },
    // 3) 현재 페이지에 해당하는 아이템들
    displayItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredItems.slice(start, start + this.itemsPerPage);
    },
  },
  watch: {
    // 전체 아이템이 바뀌면 1페이지로
    allItems() {
      this.currentPage = 1;
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      let response = await lookupApi.gameBuys({ params:{}, })
      this.allItems = response.data.data
    },

    onSearch(val) {
      this.searchKeyword = val || "";
      this.currentPage   = 1;
    },
    onClear() {
      this.searchKeyword = "";
      this.currentPage   = 1;
    },

    formatISOString,
    handleRedirect(routeName) {
      this.$router.push({ name: routeName, })
    },
    handleToDataUsePage(event, item) {
      event.stopPropagation()

      const id = item.id
      const menu = this.lookupMenu

      this.$store.commit("SET_CURRENT_DATA_ITEM", { menu, item, })
      this.$router.push({ name: "gameBuyUse", params: { id: id, }, })
    },
    handleToDataPurchasePage(event, item) {
      event.stopPropagation()

      const id = item.id
      const menu = this.lookupMenu

      this.$store.commit("SET_CURRENT_DATA_ITEM", { menu, item, })
      this.$router.push({ name: "gameBuyHistory", params: { id: id, }, })
    },
    handleClickRow(rowData) {
      const dataId = rowData.id

      this.$router.push({ name: "surveyDetail", params: { id: dataId, }, })
    },
    handleResetFilters() {
      // this.$store.dispatch("resetFilterItems")
      // this.$store.dispatch("fetchLookupData")
    },
    handleFirstPage() {
      this.currentPage = 1;
    },
    handlePrevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    handleNextPage() {
      if (this.currentPage < this.pageTotal) this.currentPage++;
    },
    handleChangeItemsPerPage() {
      // 페이지사이즈 바뀌면 무조건 1페이지로
      this.currentPage = 1;
    },
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.filter_wrapper {
  display: flex;
  justify-content: space-between;
}
.filter_item {
  list-style: none;
  margin-right: 0.75rem;
}
.footer_wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  height: 4rem;
  padding: 2.5em 0;
  height: 30px;
  font-size: 0.8rem;
  justify-content: space-between;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.5rem;
  height: 1.5rem;
  border-radius: 0.2rem;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  cursor: pointer;
}

.first_btn {
  align-items: flex-start;
  width: 128px;
}

.middle_btn {
  display: flex;
  align-items: center;
  align-self: center;
}

.btn:hover {
  background-color: rgb(228, 228, 228);
}

.page {
  margin: 0 1rem;
}

.page_selector_wrapper {
  width: 128px;
  align-items: center;
}

.page_selector {
  width: 8rem;
  font-size: 0.8rem;
}

.v-data-table-header {
  background-color: #000 !important;
}

.v-data-table-header th {
  background-color: #000 !important;
  color: #fff !important;
}
</style>

<style >
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding-left: 1rem !important;
  text-align: center;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  background-color: #000 !important;
  color: #fff;
}

.v-data-table > .v-data-table__wrapper > table {
  padding: 12px !important;
}

.theme--light.v-data-table .v-data-footer {
  border-top: 0 !important;
}
</style>
